import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { TokenTypeButton } from "../shared/TokenTypeButton";
import { BUTTON_TYPES } from "./constants";

export const Buttons = () => {
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);

  return (
    <div className="divide-primary h-full w-[23rem] divide-y overflow-y-auto">
      <div className="px-6 pt-5">
        {BUTTON_TYPES.map(button => (
          <TokenTypeButton
            key={button.value}
            tokenType={button}
            onClick={() => toggleSidebarView(button.actionView)}
          />
        ))}
      </div>
    </div>
  );
};
